<template lang="pug">
  div(class='yk-ap-wrapper8')
    div(class="yk-ap-head-info-wrapper")
       div(class="yk-ap-que-name clearfix") 
        p(class="title-file-top") {{data.title}}
        span(class="sp-button-fanhui" @click="goDetail") 返回
       div(class="yk-ap-que-btn-back") 
    div(class='yk-ap-question clearfix')
      ol(class='clearfix yk-ap-que-ol-wrapper')
        li(v-for="(li,index) in data.data" :key="index")
          el-card(class="box-card yk-box-que-wrapper" v-if="index == list.length-1" id='target')
            div(slot="header" class="clearfix yk-ap-listhead")
              div(class="yk-que-show-intro")
                span(class="yk-que-name-index") {{index+1}}
                span(class='yk-ap-type') {{questionTypeName[li.questionType-1]}}
            div( class='clearfix' v-if="true")
              true-false(:isBook="false" :canuse="false" :isdShow="true"  :isquestion="saveBtn" :iSubmit='iSubmit' :li.sync='li' @submit='submitChildQuestion'  v-if="li.questionType >=3")
              SingleChoice(:isBook="false" :canuse="false" :isdShow="true"  :isquestion="saveBtn" :iSubmit='iSubmit' :li.sync='li' @submit='submitChildQuestion' v-else)
          el-card(class="box-card yk-box-que-wrapper" v-else)
              div(slot="header" class="clearfix yk-ap-listhead")
                div(class="yk-que-show-intro")
                  span(class="yk-que-name-index") {{index+1}}
                  span(class='yk-ap-type') {{questionTypeName[li.questionType-1]}}
              div( class='clearfix' v-if="true")
                true-false(:isBook="false" :canuse="false" :isdShow="true"  :isquestion="saveBtn" :iSubmit='iSubmit' :li.sync='li' @submit='submitChildQuestion'  v-if="li.questionType >=3")
                SingleChoice(:isBook="false" :canuse="false" :isdShow="true"  :isquestion="saveBtn" :iSubmit='iSubmit' :li.sync='li'  @submit='submitChildQuestion' v-else)
</template>

<script>
import Vue from 'vue';
import TrueFalse from 'components/QuestionnaireQuestions/TrueFalse.vue';
import Multiselect from 'components/QuestionnaireQuestions/Multiselect.vue';
import SingleChoice from 'components/QuestionnaireQuestions/SingleChoice.vue';
export default Vue.extend({
  name: 'questionnaire',
  components: {
    Multiselect,
    TrueFalse,
    SingleChoice
  },
  data() {
    return {
      activeNames: [],
      editable: false,
      praname: '第一次作业名称',
      condition: '未开始',
      changeCondition: '开始',
      quesNumber: '第一题',
      diffcult: 1,
      dialogVisible: false,
      type: '判断题',
      questionTypeName: ['单选题', '多选题', '判断题', '判断题'],
      watch: false,
      del: false,
      number: 5,
      list: [],
      dataJson: [],
      queTitle: '',
      queId: '',
      quesType: 1,
      answerType: 1,
      saveBtn: false,
      submitCount: 0,
      successCount: 0,
      submitmsg: '',
      iSubmit: false,
      questionnireName: '',
      showTitle: '',
      isShowInput: false,
      submitName: '',
      allowClick: true
    };
  },
  props: {
    data: {
      type: Object,
      default: null
    },
    courseId:{
      type: String,
      default:''
    }
  },
  watch: {
    
  },

  methods: {
    goDetail(){
      this.$router.push({
        name:"teachingDetails",
        params: {
          bookId: this.courseId
        }
      })
    },
    deleteQuestion: function(index, id) {
      var that = this;
      let askMessage = '是否删除该题目?';
      let questionnaireId = '';
      if (this.list.length == 1) {
        askMessage = '删除最后一题会自动删除问卷调查哦~';
        questionnaireId = this.questionnaireId;
      }
      this.$confirm(askMessage, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$http.post("/api/XOrg/BookMaterial/delQuestion",{
          questionId: id,
          questionnaireId:questionnaireId
        }).then(function(rst) {
          if (rst.code >0) {
            that.list.splice(index, 1);
            that.$message({
              type: 'success',
              message: rst.msg
            });
            if (that.list.length == 0) {
              that.returnPrevPage();
            }
          } else {
            that.$message({
              type: 'warning',
              message: rst.msg
            });
          }
        });
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    addChoice: function(type) {
      let order = this.list.length + 1;
      this.list.push({
        ContentText: '',
        questionType: type,
        questionId: '',
        dataJson: [
          {
            Content: '',
            SortOrder: 0
          },
          {
            Content: '',
            SortOrder: 1
          },
          {
            Content: '',
            SortOrder: 2
          },
          {
            Content: '',
            SortOrder: 3
          }
        ],
        sortOrder: order
      });
      this.gotoTarget();
    },
    addTrueFalse: function(type) {
      let order = this.list.length + 1;
      let contents = type == 3 ? ['正确', '错误'] : ['赞成', '反对'];
      this.list.push({
        ContentText: '',
        questionType: type,
        questionId: '',
        sortOrder: order,
        dataJson: [
          {
            Content: contents[0]
          },
          {
            Content: contents[1] 
          }
        ]
      });
      this.gotoTarget();
    },
    getQuestionnaireQuesList: function() {
      let courseId=this.courseId;
      let questionnaireId = this.questionnaireId;
      var that = this;
      this.$http.post("/api/XOrg/BookMaterial/getQuestionnaireStatistics",{
        courseId: 'qpxpaieqf7xjsvtx3heghw',
        questionnaireId:'ffwrayuqjrtgzssyzfj3vq'
      }).then(function(rst) {
        that.list = rst.data;
        that.questionnireName = rst.title;
        that.allowClick = true;
      });
    },
    returnPrevPage: function() {
      this.$router.go(-1);
    },
    moveUp: function(index) {
      // 上移题目
      let temp = this.list[index];
      this.list[index] = this.list[index - 1];
      this.list[index - 1] = temp;
      this.list[index - 1].sortOrder = index;
      this.list[index].sortOrder = index + 1;
      this.list.push({ code: 1 });
      this.list.pop();
    },
    moveDown: function(index) {
      // 下移题目
      let temp = this.list[index];
      this.list[index] = this.list[index + 1];
      this.list[index + 1] = temp;
      this.list[index + 1].sortOrder = index + 2;
      this.list[index].sortOrder = index + 1;
      this.list.push({ code: 1 });
      this.list.pop();
    },
    sendAllRequest() {
      if (!this.allowClick) {
        this.$message('请不要老是点我啦~');
        return;
      }
      if (this.list.length == 0) {
        this.$message('您至少添加一题才能保存哦~');
      } else {
        // 向子页面发送提交事件的命令
        this.iSubmit = true;
        this.allowClick = false;
      }
    },
    submitChildQuestion: function(obj) {
      var that = this;
      // 子页面返回数据的个数
      this.submitCount = this.submitCount + obj.count;
      // 子页面通过数据验证的个数
      this.successCount = this.successCount + obj.code;
      if (obj.code == 0) {
        this.submitmsg = this.submitmsg + obj.msg + '<br />';
      }

      if (this.list.length == this.submitCount) {
        this.iSubmit = false;
        if (this.list.length == this.successCount) {
          let questionJson = JSON.stringify(this.list);
          
          this.$http.post("/api/XOrg/BookMaterial/updateQuestionnaireQuestions",{
            courseId: this.courseId,
            courseOpenId:this.openCourseId,
            questionnaireId:this.questionnaireId,
            questionnaireName: this.submitName,
            questionJson:questionJson
          }).then(function(rst) {
            if (rst.questionnaireId) {
              that.$router.push({
                name: 'questionnaire',
                params: {
                  questionnaireId: rst.questionnaireId,
                  courseId: that.courseId
                }
              });
              // that.getQuestionnaireQuesList();
            } else {
              that.allowClick = true;
            }

            if (rst.code > 0) {
              that.$message(rst.msg);
            } else {
              that.$message(rst.msg);
            }
          });
        } else {
          this.$message({
            showClose: true,
            dangerouslyUseHTMLString: true,
            message: this.submitmsg
          });
          this.allowClick = true;
        }
        this.submitCount = 0;
        this.successCount = 0;
        this.submitmsg = '';
      }
    },
    gotoTarget: function() {
      this.$scrollTo('#target', 100, {
        offset: 500
      });
    },
    showTitleInput: function() {
      this.isShowInput = true;
    },
    hideTitleInput: function() {
      this.isShowInput = false;
    }
  },
  created() {
    // this.getQuestionnaireQuesList();
  }
});
</script>

<style lang="scss">
.yk-ap-wrapper8 {
  width: 100%;
  height: auto;
  padding-top: 15px;
  .yk-ap-head-info-wrapper {
    
    // margin: 0 20px;
    padding-bottom: 10px;
    // border-bottom: 1px solid #596880;
    line-height: 40px;
    .yk-ap-que-name {
      height: 42px;
      padding: 0px 20px;
      line-height: 42px;
      background: #5c9eff;
      font-size: 16px;
      color: #fff;
      font-weight: bold;
    }
    .yk-ap-que-btn-back {
      float: right;
    }
  }
  .yk-ap-head-info-wrapper:after {
    content: "";
    height: 0;
    visibility: hidden;
    display: block;
    clear: both;
  }
  .yk-ap-header {
    width: 100%;
    height: 50px;
    // position: fixed;
    top: 60px;
    left: 0;
    z-index: 50;
    // box-shadow: #eee 2px 6px 6px 0px;
    a {
      line-height: 50px;
      font-size: 20px;
      color: #aaa;
      margin-left: 20px;
      text-decoration: none;
      display: block;
      float: left;
    }
    .yk-ap-condition {
      float: right;
      line-height: 50px;
      margin-right: 20px;
      .yk-condition {
        margin-right: 20px;
      }
    }
  }
  .yk-ap-question {
    background: #fff;
    min-height: 500px;
    ol {
      list-style: none;
      width: 100%;
      height: auto;
      padding: 0;
      li {
        margin-top: 20px;
        float: left;
        width: 100%;
        .yk-ap-listhead {
          .yk-que-show-intro {
            float: left;
            font-size: 18px;
            .yk-que-name-index{
                display:inline-block;
                width:30px;
                height:30px;
                background-color: #fff;
                margin-right:10px;
                color:#293140;
                border-radius: 50%;
                text-align: center;
                line-height: 30px;
            }
          }
          .yk-ap-operation {
            float: right;
          }
          .yk-ap-diffcult {
            margin-left: 30px;
          }
          .yk-ap-operation {
            font-size: 20px;
            a {
              text-decoration: none;
              color: #303133;
            }
            a:hover {
              color: #409eff;
            }
          }
        }
        .yk-box-que-wrapper {
          background-color: #f5f5f5;
          border: none;
          // color: #fff;
          border-radius: 10px;
          .el-card__header {
            border-bottom: 1px solid #596880;
          }
        }
      }
    }
    .yk-ap-aquestion {
      position: fixed;
      list-style: none;
      top: 100px;
      right: 30px;
      width: 150px;
      height: auto;
      cursor: pointer;
      .el-collapse-item__header {
        width: 100%;
        height: 35px;
        line-height: 35px;
        background-color: #fff;
        text-align: center;
        // color: #fff;
        i {
          line-height: 35px;
        }
      }
      li {
        width: 100%;
        height: 35px;
        line-height: 35px;
        background-color: #409eff;
        text-align: center;
        border-top: 1px solid #eee;
        a {
          // color: #fff;
        }
      }
      li:hover {
        background-color: #316eae;
      }
    }
  }
  .width_limit {
    position: fixed;
    right: 35px;
    top: right;
    width: 210px;
    top: 300px;
    height: 315px;
    border-radius: 10px;
    .yk-qu-add-question-title {
      padding-left: 20px;
      height: 50px;
      background-color: #e6e0e0;
      border-radius: 10px 10px 0 0;
      border-bottom: 1px solid #5b6d8a;
      // color: #fff;
      font-size: 20px;
      line-height: 50px;
    }
    .yk-qu-question-type,
    .yk-qu-question-type-btn {
      height: 50px;
      background-color: #f5f5f5;
      // color: #fff;
      border-bottom: 1px solid #5b6d8a;
      line-height: 50px;
      .yk-que--s-name {
        font-size: 18px;
        margin-right: 50px;
        margin-left: 10px;
      }
      .wl-icon-dian {
        margin-left: 20px;
      }
      .fh-icon-tianjia {
        color: #F56C6C;
        font-size: 18px;
        border-radius: 50%;
        background-color: #f5f5f5;
        border: 1px solid;
      }
    }
    .yk-qu-question-type-btn {
      text-align: center;
      height: 70px;
      line-height: 70px;
      border-radius: 0 0 10px 10px;
    }
  }
  .title-file-top{
    float: left;
    width: 80%;
    overflow: hidden;
    text-overflow:ellipsis;
    white-space: nowrap;
  }
  .sp-button-fanhui{
    float: right;
    cursor: pointer;
  }
}
</style>